module.exports = __webpack_public_path__ + "img/64.484c315d.jpg";